import * as CONSTANTS from '../../../../constants/pdf-report-download'
import { PDFOptionsForm } from '../../../../lib/types/ReportDownload.type'

const getFontStyle = (style: typeof CONSTANTS.HEADER_STYLES[number], field: 'header1' | 'header2' | 'footer') => {
  if (style === 'Regular') return `${field}_font_style=>"normal",`
  if (style === 'Bold') return `${field}_bold=>"1",`
  if (style === 'Italics' || style === 'Bold Italics') return `${field}_font_style=>"${style}",`
  return ''
}
const getLogoDisplay = (val: 'no_logo' | 'first_page_only' | 'header_has_logo') => {
  if (val === 'no_logo') return ''
  if (val === 'header_has_logo') return 'logo_repeat=>"every_page",'
  return 'logo_repeat=>"first_page_only",'
}
const getFooterFields = (showDate: boolean, showPageNumbers: boolean) => {
  if (!showDate && !showPageNumbers) return ''
  if (showDate && !showPageNumbers) return 'footer_fields=>"report_timestamp",'
  if (showPageNumbers && !showDate) return 'footer_fields=>"page_number",'
  return 'footer_fields=>"page_number,report_timestamp",'
}

export const genPdfOptionsString = (values: PDFOptionsForm): string => {
    const optionsString = `
      paper_size=>"${values.paper_size}",
      font_size=>"${values.font_size}",
      orientation=>"${values.orientation}",
      ${getLogoDisplay(values.header_has_logo)}
      header1_text=>"${values.header1_text}",
      header1_font=>"${values.header1_font}",
      header1_font_size=>"${values.header1_font_size}",
      ${getFontStyle(values.header1_font_style, 'header1')}
      header1_position=>"${values.header1_position.toLowerCase()}",
      header1_color=>"${values.header1_color}",
      header2_text=>"${values.header2_text}",
      header2_font=>"${values.header2_font}",
      header2_font_size=>"${values.header2_font_size}",
      ${getFontStyle(values.header2_font_style, 'header2')}
      header2_position=>"${values.header2_position.toLowerCase()}",
      header2_color=>"${values.header2_color}",
      footer_text=>"${values.footer_text}",
      footer_font=>"${values.footer_font}",
      footer_font_size=>"${values.footer_font_size}",
      ${getFontStyle(values.footer_font_style, 'footer')}
      footer_text_position=>"${values.footer_position.toLowerCase()}",
      footer_color=>"${values.footer_color}",
      ${getFooterFields(values.footer_date, values.footer_page_numbers)}
      date_position=>"${values.date_position.toLowerCase()}",
      page_number_position=>"${values.page_number_position.toLowerCase()}",
      top_margin=>"${values.top_margin}in",
      bottom_margin=>"${values.bottom_margin}in",
      left_margin=>"${values.left_margin}in",
      right_margin=>"${values.right_margin}in",
    `
    return optionsString
}
